import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/ContractRatesController/CreateContractRatesController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateContractRates({ contract, onClose, onSuccess }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ ContractRate: '', ContractRateAmount: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (contract) {
            setFormData({ ContractRate: contract.ContractRate, ContractRateAmount: contract.ContractRateAmount });
        } else {
            setFormData({ ContractRate: '', ContractRateAmount: '' }); // Clear form data when switching to add mode
        }
    }, [contract]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission
        if (contract) {
            formData.ID = contract.ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            redirectCallback();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            redirectUserList();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="contractRateModal" tabIndex="-1" aria-labelledby="contractRateModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{contract ? "Edit Contract Rate" : "Add Contract Rate"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Contract Rate:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="ContractRate" value={formData.ContractRate} onChange={handleFieldChange} />
                                        {errors.ContractRate && <div style={{ color: 'red' }}>{errors.ContractRate}</div>}
                                    </div>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Amount:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="ContractRateAmount" value={formData.ContractRateAmount} onChange={handleFieldChange} />
                                        {errors.ContractRateAmount && <div style={{ color: 'red' }}>{errors.ContractRateAmount}</div>}
                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true">  {contract ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateContractRates;